import { useAuth } from "hooks/auth";
import useSWRImmutable from "swr/immutable";
import { getEnvVariable } from "utilities/env";

export interface Translations {
  [key: string]: string;
}

const translationUrl = `${getEnvVariable("REACT_APP_API_URL")}/translation`;

export const flushTranslationsCache = () => {
  localStorage.removeItem(translationUrl);
};

export const useInternationalisation = () => {
  const { fetcher } = useAuth();

  const useTranslation = (
    customTranslationSelectedByCurrentUser?: string,
  ): { data?: Translations; mutate?: () => any } => {
    return useSWRImmutable(
      () =>
        `${translationUrl}${customTranslationSelectedByCurrentUser ? `?_locale=${customTranslationSelectedByCurrentUser}` : ""}`,
      fetcher,
    );
  };

  return {
    useTranslation,
  };
};
